import { createApi } from '@reduxjs/toolkit/query/react';
import { createBaseQuery, toQueryParams } from 'helpers/api';

export const emailTemplatesApi = createApi({
  reducerPath: 'emailTemplatesApi',
  baseQuery: createBaseQuery('email_templates'),
  tagTypes: ['EmailTemplate'],
  endpoints: builder => ({
    getEmailTemplates: builder.query({
      query: params => `?${toQueryParams(params || {})}`,
      transformResponse: ({ result }) => result,
      providesTags: ['EmailTemplate'],
    }),
    createEmailTemplate: builder.mutation({
      query: data => ({
        url: '/',
        method: 'POST',
        body: data,
      }),
      transformResponse: ({ result }) => result,
      invalidatesTags: ['EmailTemplate'],
    }),
    updateEmailTemplate: builder.mutation({
      query: ({ id, ...data }) => ({
        url: `/${id}`,
        method: 'PUT',
        body: data,
      }),
      transformResponse: ({ result }) => result,
      invalidatesTags: ['EmailTemplate'],
    }),
    deleteEmailTemplate: builder.mutation({
      query: id => ({
        url: `/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['EmailTemplate'],
    }),
    duplicateEmailTemplate: builder.mutation({
      query: id => ({
        url: `/${id}/duplicate`,
        method: 'POST',
      }),
      transformResponse: ({ result }) => result,
      invalidatesTags: ['EmailTemplate'],
    }),
    getEmailTemplateDefaultPreview: builder.query({
      query: ({ type, brandId, emailTemplateId }) =>
        `/default_preview?type=${type}${brandId ? `&brand_id=${brandId}` : ''}${
          emailTemplateId ? `&email_template_id=${emailTemplateId}` : ''
        }`,
      transformResponse: ({ result }) => result,
    }),
  }),
});

export const {
  useGetEmailTemplatesQuery,
  useLazyGetEmailTemplatesQuery,
  useCreateEmailTemplateMutation,
  useUpdateEmailTemplateMutation,
  useDeleteEmailTemplateMutation,
  useDuplicateEmailTemplateMutation,
  useGetEmailTemplateDefaultPreviewQuery,
  useLazyGetEmailTemplateDefaultPreviewQuery,
} = emailTemplatesApi;
